<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="500px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <el-form ref="form" :model="formData" size="small" onsubmit="return false">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-input
            type="textarea"
            v-model="formData.linkData"
            :rows="3"
            maxlength="1000"
          >
          </el-input>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close()">{{
        this.$l('INDEX.btn_cancel') || '取消'
      }}</el-button>
      <el-button type="primary" size="small" @click="confirm()">{{
        this.$l('INDEX.btn_save') || '保存'
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
const initForm = {
  linkData: '',
}

import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],
  props: {
    visible: {type: Boolean, default: false},
    title: {type: String, default: ''},
    shipmentCode: {type: String, default: ''},
    shipmentStatus: {type: String, default: ''},
  },
  data() {
    return {
      formData: {...initForm},
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.formData = {...initForm}
      }
    },
  },
  methods: {
    confirm() {
      if (
        this.formData.linkData === undefined ||
        this.formData.linkData === null ||
        this.formData.linkData === ''
      ) {
        this.$message({
          showClose: true,
          message:
            this.$l('please_input_back_reason') ||
            '请输入回退原因！',
          type: 'warning',
        })
        return
      }
      this.loadingOpen()
      this.$api
        .shipmentInfoBookingBackApi({
          shipmentCode: this.shipmentCode,
          shipmentStatus: this.shipmentStatus,
          linkData: this.formData.linkData,
        })
        .then((res) => {
          this.loadingClose()
          const {status} = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
            this.close()
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
